import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client.js";
import { TerritoryMap } from "@/components/TerritoryMap.jsx";
import { EXPEDITION, LODGING, PUBLIC_SERVICES, PUBLIC_RESOURCES, SEPAQ_CHALET_URL } from "@/content/expedition.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function LodgingPage() {
  const { ui, lang } = useOrignalUi();
  const [lodge, setLodge] = useState(null);

  useEffect(() => {
    api("/api/lodgings")
      .then((d) => setLodge((d.items || [])[0] || null))
      .catch(() => {});
  }, []);

  const name = lodge?.name || LODGING.name;
  const sector = lodge?.sector || LODGING.sector;
  const reserve = lodge?.reserve || LODGING.reserve;
  const sourceUrl = lodge?.source_url || SEPAQ_CHALET_URL;
  const sourceName = lodge?.source_name || LODGING.sourceName;
  const checked = lodge?.source_checked_at || LODGING.consulted;

  return (
    <main className="og-page" data-testid="page-lodging">
      <header className="og-hero og-hero--compact">
        <div className="og-hero__cover" aria-hidden="true" />
        <div className="og-hero__copy">
          <p className="og-kicker">{ui.lodging.folder}</p>
          <h1>{ui.lodging.title}</h1>
          <p>{ui.lodging.subtitle}</p>
        </div>
      </header>

      <section className="og-card" data-testid="chalet-card">
        <p className="og-kicker">{ui.expedition.ourLodge}</p>
        <h2>{name}</h2>
        <p>{reserve}</p>
        <p>{ui.expedition.sectorBadge}</p>
        <p>{ui.lodging.holder} · Luc Young</p>
        <p>28–30 août 2026 · 17 h → 13 h 30</p>
        <p className="og-crit" data-testid="water-critical">{ui.lodging.water}</p>
        <p>{ui.lodging.groupBed}</p>
        <p className="og-hint">{ui.lodging.provided}</p>
        <p className="og-hint">{ui.lodging.notProvided}</p>
        <p className="og-hint">{ui.lodging.source} · {sourceName} · {checked}</p>
        <dl className="og-dl">
          <dt>{ui.lodging.unit}</dt>
          <dd>{lodge?.address || ui.lodging.unknown}</dd>
          <dt>{ui.lodging.gps}</dt>
          <dd>{lodge?.latitude != null && lodge?.longitude != null ? `${lodge.latitude}, ${lodge.longitude}` : ui.lodging.unknown}</dd>
          <dt>{ui.lodging.capacity}</dt>
          <dd>{lodge?.capacity || ui.lodging.unknown}</dd>
        </dl>
        <p className="og-hint">{ui.lodging.photosNote}</p>
        <div className="og-toolbar">
          <a className="og-btn og-btn--primary" href={sourceUrl} target="_blank" rel="noreferrer" data-testid="sepaq-link">{ui.expedition.seeSepaq}</a>
          <a className="og-btn" href={sourceUrl} target="_blank" rel="noreferrer">{ui.expedition.seePhotos}</a>
          <Link className="og-btn" to="/territoire/carte">{ui.nav.map}</Link>
          <Link className="og-btn" to="/sejour">{ui.today.stay}</Link>
        </div>
      </section>

      <section className="og-card" data-testid="reception-card">
        <h3>{ui.trip.reception}</h3>
        <p>{lang === "en" ? PUBLIC_SERVICES.reception.titleEn : PUBLIC_SERVICES.reception.title}</p>
        <p>{PUBLIC_SERVICES.reception.address}</p>
        <p>{PUBLIC_SERVICES.reception.phone}</p>
        <p>{lang === "en" ? PUBLIC_SERVICES.reception.servicesEn : PUBLIC_SERVICES.reception.services}</p>
        <p>{lang === "en" ? PUBLIC_SERVICES.reception.nearbyEn : PUBLIC_SERVICES.reception.nearby}</p>
        <p className="og-hint">{PUBLIC_SERVICES.reception.source} · {PUBLIC_SERVICES.reception.consulted}</p>
        <a className="og-btn" href={PUBLIC_SERVICES.reception.url} target="_blank" rel="noreferrer">{ui.documents.open}</a>
      </section>

      <section className="og-card" data-testid="motorized-card">
        <h3>{ui.trip.motorized}</h3>
        <p>{lang === "en" ? PUBLIC_SERVICES.motorized.ruleEn : PUBLIC_SERVICES.motorized.rule}</p>
        <p><strong>{lang === "en" ? PUBLIC_SERVICES.motorized.verifyEn : PUBLIC_SERVICES.motorized.verify}</strong></p>
        <p className="og-hint">{PUBLIC_SERVICES.motorized.source} · {PUBLIC_SERVICES.motorized.consulted}</p>
        <a className="og-btn" href={PUBLIC_SERVICES.motorized.url} target="_blank" rel="noreferrer">{ui.documents.open}</a>
      </section>

      <section className="og-card">
        <h3>{ui.expedition.territoryBlock}</h3>
        <p className="og-hint">{ui.expedition.mapNote}</p>
        <TerritoryMap center={EXPEDITION.mapCenter} zoom={EXPEDITION.mapCenter.zoom} points={[]} />
      </section>

      <section className="og-card">
        <h3>{ui.trip.resources}</h3>
        {PUBLIC_RESOURCES.filter((r) => r.id !== "avenza").map((r) => (
          <article key={r.id} className="og-food-card">
            <span>{r.icon} </span>
            <a href={r.url} target="_blank" rel="noreferrer">{r.title}</a>
            <p className="og-hint">{r.source} · {r.consulted}</p>
            <p>{lang === "en" ? r.noteEn || r.note : r.note}</p>
          </article>
        ))}
      </section>
    </main>
  );
}
